import RecommendationBox from "./src/RecommendationBox.vue";
export default RecommendationBox;
